import { recoverConfigSchema } from "@redotech/redo-model/recover-config";
import * as z from "zod/v4";

export const getRecoverConfigs = {
  name: "getRecoverConfigs" as const,
  input: z.object({}),
  output: z.object({ configs: z.array(recoverConfigSchema) }),
};
